import { createSelector }        from 'reselect';
import {
  createSelectResourceErrorsState,
  createSelectResourceInProgressState,
  createSelectResourceItemsByIds
}                                from './resourceSelectors';
import { resourceNames }         from '../config/resources.config';
import { selectJwtIfNotExpired } from './auth';
import { prepareRequestKey }     from '../reducers/utils/apiResources/prepareRequestKey';
import { METHOD_GET }            from '../actions/utils/apiResources/apiResourceActions.const';


const resourceName = resourceNames.USERS;


export const selectAllUsersByIds = createSelector(
  createSelectResourceItemsByIds(resourceName),
  (usersById) => usersById,
);


export const selectCurrentUser = createSelector(
  selectJwtIfNotExpired,
  selectAllUsersByIds,
  (jwt, usersById) => (jwt && usersById.get(jwt.get('userId'))) || null
);


export const selectCurrentUserLoadInProgress = createSelector(
  selectJwtIfNotExpired,
  createSelectResourceInProgressState(resourceName),
  (jwt, inProgressState) => !!(
    jwt
    && inProgressState.get(prepareRequestKey({method: METHOD_GET, url: jwt.get('userId')}))
  ) || false
);


export const selectCurrentUserLoadError = createSelector(
  selectJwtIfNotExpired,
  createSelectResourceErrorsState(resourceName),
  (jwt, errorState) => (
    jwt
    && errorState.get(prepareRequestKey({method: METHOD_GET, url: jwt.get('userId')}))
  ) || null
);


export const selectCurrentUserCapabilities = createSelector(
  selectJwtIfNotExpired,
  selectAllUsersByIds,
  (jwt, usersById) => (jwt && usersById.getIn([`${jwt.get('userId')}/capabilities`, 'capabilities'])) || null
);



// WEBPACK FOOTER //
// ./src/selectors/users.js